module.exports = __webpack_public_path__ + "img/privacy-all.55fc648b.svg";